import {getCurrentUser} from 'main/services/auth/jwt-auth';
import {GET_AUTH_INFO} from 'shared/constants/ActionTypes';

const initialState = {
  authInfo: getCurrentUser(),
};

const MemberReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTH_INFO:
      return {
        ...state,
        authInfo: action.payload,
      };
    default:
      return state;
  }
};

export default MemberReducer;
